var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-icon',{attrs:{"small":""}},[_vm._v(" location_on ")]),_vm._v(" "+_vm._s(_vm.yacht.current_base.name)+", "+_vm._s(_vm.yacht.current_base.country.name)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }